export default "__VITE_ASSET__DmnoOWub__"